/**
 * usePermissions Hook
 * Hook för att enkelt kontrollera permissions (RBAC + paket)
 */

import { useEffect } from 'react';
import { usePermissionsStore } from '@/store/permissionsStore';
import { useAuth } from '@/store/authStore';

export const usePermissions = () => {
  const { user } = useAuth();
  const {
    permissions,
    packageFeatures,
    isLoading,
    error,
    fetchPermissions,
    setAdminPermissions,
    hasFeatureAccess,
    hasPackageAccess,
    hasActionAccess,
    getAccessibleFeatures,
    isDemo,
    isTrial,
    getTrialDaysRemaining,
  } = usePermissionsStore();

  useEffect(() => {
    if (!user?.id || !user?.organization_id) return;
    if (permissions || isLoading) return;

    // Global admin / SYS_ADMIN → sätt syntetiska permissions utan nätverksanrop
    if (user.is_global_admin) {
      setAdminPermissions(user.id, user.organization_id);
      return;
    }

    fetchPermissions(user.id, user.organization_id);
  }, [user?.id, user?.organization_id, permissions, isLoading]);

  return {
    permissions,
    packageFeatures,
    isLoading,
    error,
    hasFeatureAccess,
    hasPackageAccess,
    hasActionAccess,
    getAccessibleFeatures,
    isDemo,
    isTrial,
    getTrialDaysRemaining,
    isUnlimited: packageFeatures?.isUnlimited ?? false,
    refetch: () => {
      if (user?.id && user?.organization_id) {
        fetchPermissions(user.id, user.organization_id);
      }
    },
  };
};

